import React from "react";
import { Link } from "react-router-dom";

export default class WorkdocTabs extends React.Component {
  render() {
    let nav = {
      default: "Все",
      me: "Мне",
      my: "Мои",
      draft: "Черновики",
      add: <span className="flaticon2-add-1"></span>,
    };
    return (
      <ul className="nav nav-tabs mb-4">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/workdoc/${id}/${this.props.structureId}/`}
              className={` ${
                this.props.listMode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
